export const BILL_RATE_TYPES = {
  1: 'Hourly',
  2: 'Monthly',
  3: 'Annual'
}

export const HOURLY = 1

export const MONTHLY = 2

export const ANNUAL = 3
